import { PtLuxonDate } from '../projects/date.models';
import { User } from '../../_foundation/models/security.models';
import { ValidationError } from '../projects/validation.models';

export class ImplementerEditor {
  minLockableDate: PtLuxonDate;
  maxLockableDate: PtLuxonDate;
  sjhSuggestedMaxLockableDate: PtLuxonDate;
  isLocked: boolean;
  startDate: PtLuxonDate;
  endDate: PtLuxonDate;
  latestDate: PtLuxonDate;
  implementerUrl: string;
  environmentTypeId: number;
}

export enum ImplementerEnvironmentType {
  SeajacksHouse = 1,
  Vessel = 2
}

export class ImplementerSnapshotSummary {
  id: number;
  startDate: PtLuxonDate;
  endDate: PtLuxonDate;
  databaseBackupId: string;
  environmentType: ImplementerEnvironmentType;

  mergeDate: PtLuxonDate;
  mergedBy: User;
  mergeDateShowUtc: string;

  creationTime: PtLuxonDate;
  activatedBy: User;

  cancellationDate: PtLuxonDate;
  cancelledBy: User;

  // local only
  activationDateToShow: string;
  startDateToShow: string;
  endDateToShow: string;
  isActive: boolean;
  mergeDateToShow: string;

  implementerUrl: string;
  vesselUrl: string;
}

export class ValidationErrors {
  changes: ValidationError[] = [];
}

export interface ImplementerOperationError {
  type: number;
  message: string;
  errorMessage: string;
}

export interface ImplementerOperationFailure {
  isValid: boolean;
  operation: string;
  stage: string;
  statusCode: number;
  errors: ImplementerOperationError[];
}



// WEBPACK FOOTER //
// ./src/models/implementer/implementer.models.ts